import React, { Component } from 'react';
import { observer, inject } from 'mobx-react'

@inject("panelStore") @observer 
export default class ToogleButton extends Component {
  constructor(props){
    super(props)
  }
  render() {
    let { panelStatus, toggleResizePanel, togglePanel } = this.props.panelStore;
    return (
      <header className="billy-header">
        <div role="heading" className="billy-header__title">Billy</div>
        <div className="billy-header__actions">
          <button className="billy-header__button billy-button billy-bc_action_resize fi-billy fi-billy-resize" 
                  onClick={ toggleResizePanel } 
                  aria-label={`${ panelStatus.isResizeOn ? 'הקטן' : 'הדגל' } מסך`}>
          </button>
          <button className="billy-header__button billy-button billy-bc_action_close fi-billy fi-billy-close" 
                  onClick={ togglePanel } 
                  aria-label="סגור מסך">
          </button>
        </div>
      </header>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Header/index.js